import { TypographyV3 } from '@jouzen/ecom-components';
import type { ReactNode } from 'react';

import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';
import RichText from '@/app/components/RichText';

import { hardwareEducationCardsData } from '../_data/hardwareEducationCardsData';

const HardwareEducationSection = () => {
  return (
    <section>
      <TypographyV3
        className="px-6 py-10 text-center text-4xl font-light md:text-6xl"
        data-cy="hardware-education-title"
      >
        <RichText
          messageKey="pop_gen4_posthero_title"
          tValues={{
            em: (chunks: ReactNode) => (
              <em className="font-serif italic">{chunks}</em>
            ),
          }}
        />
      </TypographyV3>
      <div className="pt-0 pb-10 md:py-20">
        <LandingPageCards cards={hardwareEducationCardsData} />
      </div>
    </section>
  );
};

export default HardwareEducationSection;
